<template>
  <header class="modal-header border-bottom">
    <div class="label-text" v-if="back" @click="backClicked">戻る</div>

    <div class="title">{{ title }}</div>

    <div class="label-text icon-close" @click="closeClicked">地図表示</div>
  </header>
</template>

<script>
import IconClose from "../assets/icon-close.svg"

export default {
  props: ["back", "title", "label"],

  data() {
    return {
      iconClose: IconClose
    }
  },

  methods: {
    backClicked() {
      this.$emit("backClicked")
    },

    closeClicked() {
      this.$emit("closeClicked")
    }
  }
}
</script>

<style scoped>
.modal-header {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 44px;
  background-color: #fff;
  z-index: 2;
}

.modal-header .icon-close {
  position: absolute;
  right: 4px;
  padding: 10px;
}

.modal-header .icon-close img {
  width: 100%;
}

.modal-header .title {
  position: absolute;
  left: 50%;
  width: 240px;
  margin-left: -120px;
  line-height: 44px;
  font-weight: bold;
  text-align: center;
}

.modal-header .label-text {
  color: #f05353;
  padding-left: 20px;
}
</style>
